import { Callout, calloutSlashItem } from './callout';
import { HeadlineImage, headlineImageSlashItem } from './headline_image';
import { Gate, gateSlashItem } from './gate';
import { SlashMenu } from './slash_menu';

export { Callout, SlashMenu };

// Registry of all rich-content block extensions.
// Each entry: { name, extension, slashItem? }
// Enable per-editor via data-tiptap-extensions-value='["callout"]'.
// Adding extension #N: import it above, add an entry here — no other changes needed.
export const EXTENSION_REGISTRY = [
  { name: 'callout', extension: Callout, slashItem: calloutSlashItem, serverTemplates: true, templatePath: '/dashboard/shared/tiptap/callout', renderPath: '/dashboard/shared/tiptap/callout/render' },
  { name: 'headline-image', extension: HeadlineImage, slashItem: headlineImageSlashItem },
  { name: 'gate', extension: Gate, slashItem: gateSlashItem, serverTemplates: true, templatePath: '/dashboard/shared/tiptap/gate' },
];
